import {
  FETCH_ITEMCATEGORY_INIT_ACTION,
  FETCH_ITEMCATEGORY_SUCCESS_ACTION,
  FETCH_ITEMCATEGORY_FAIL_ACTION
} from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_ITEMCATEGORY_SUCCESS_ACTION:
      return {
        ...state,
        itemCategoryList: action.payload.rows,
        itemCategoryCount: action.payload.count
      };

    default:
      return {
        ...state
      };
  }
}
